import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const LikeDislike: React.FC = () => {
  const [likes, setLikes] = useState<number>(0);
  const [dislikes, setDislikes] = useState<number>(0);
  const [userReaction, setUserReaction] = useState<'like' | 'dislike' | null>(null);

  useEffect(() => {
    const savedLikes = localStorage.getItem('likes');
    const savedDislikes = localStorage.getItem('dislikes');
    const savedUserReaction = localStorage.getItem('userReaction');

    if (savedLikes) setLikes(Number(savedLikes));
    if (savedDislikes) setDislikes(Number(savedDislikes));
    if (savedUserReaction) setUserReaction(savedUserReaction as 'like' | 'dislike');
  }, []);

  const handleLike = () => {
    if (userReaction === 'like') {
      setLikes(likes - 1);
      setUserReaction(null);
      localStorage.setItem('likes', String(likes - 1));
      localStorage.setItem('userReaction', '');
    } else {
      if (userReaction === 'dislike') {
        setDislikes(dislikes - 1);
        localStorage.setItem('dislikes', String(dislikes - 1));
      }
      setLikes(likes + 1);
      setUserReaction('like');
      localStorage.setItem('likes', String(likes + 1));
      localStorage.setItem('userReaction', 'like');
    }
  };

  const handleDislike = () => {
    if (userReaction === 'dislike') {
      setDislikes(dislikes - 1);
      setUserReaction(null);
      localStorage.setItem('dislikes', String(dislikes - 1));
      localStorage.setItem('userReaction', '');
    } else {
      if (userReaction === 'like') {
        setLikes(likes - 1);
        localStorage.setItem('likes', String(likes - 1));
      }
      setDislikes(dislikes + 1);
      setUserReaction('dislike');
      localStorage.setItem('dislikes', String(dislikes + 1));
      localStorage.setItem('userReaction', 'dislike');
    }
  };

  // const totalReactions = likes + dislikes;
  // const likePercentage = totalReactions ? (likes / totalReactions) * 100 : 0;
  // const dislikePercentage = totalReactions ? (dislikes / totalReactions) * 100 : 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* <Typography variant="body2" sx={{ minHeight: '24px' }}>
          {userReaction === 'like' ? `${likePercentage.toFixed(1)}%` : ''}
        </Typography> */}
        <IconButton onClick={handleLike} color={userReaction === 'like' ? 'primary' : 'default'}>
          <ThumbUpIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* <Typography variant="body2" sx={{ minHeight: '24px' }}>
          {userReaction === 'dislike' ? `${dislikePercentage.toFixed(1)}%` : ''}
        </Typography> */}
        <IconButton onClick={handleDislike} color={userReaction === 'dislike' ? 'secondary' : 'default'}>
          <ThumbDownIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default LikeDislike;
